<template>
  <Card
    class="layout-card"
    style="height: 100%; overflow-y: auto; overflow-x: hidden"
  >
    <!-- 列表模式 -->
    <template v-if="!showEdit">
      <div class="header-container">
        <div class="search-form">
          <MultiCascader
            v-model="searchForm.countryCodes"
            :data="countryLi"
            placeholder="国家名称"
            style="width: 250px"
          />
          <Select
            v-model="searchForm.device"
            placeholder="开启设备"
            clearable
            style="width: 150px"
          >
            <Option :value="-1">iOS+Android</Option>
            <Option :value="0">iOS</Option>
            <Option :value="1">Android</Option>
          </Select>
          <Select
            v-model="searchForm.entryPoints"
            multiple
            placeholder="开放入口"
            clearable
            style="width: 150px"
          >
            <Option
              v-for="item in entryOptions"
              :value="Number(item.dictValue)"
              :key="item.dictValue"
              >{{ item.dictName }}</Option
            >
          </Select>
          <Select
            v-model="searchForm.payMethods"
            multiple
            placeholder="支付方式"
            clearable
            style="width: 150px"
          >
            <Option
              v-for="item in allMethodOptions"
              :value="Number(item.dictValue)"
              :key="item.dictValue"
              >{{ item.dictName }}</Option
            >
          </Select>
          <Select
            v-model="searchForm.providers"
            multiple
            placeholder="支付服务商"
            clearable
            style="width: 150px"
          >
            <Option
              v-for="item in providerOptions"
              :value="Number(item.dictValue)"
              :key="item.dictValue"
              >{{ item.dictName }}</Option
            >
          </Select>
          <Input
            v-model="searchForm.name"
            placeholder="请输入策略名称搜索"
            clearable
            style="width: 200px"
          />
          <Button type="primary" @click="handleSearch">搜索</Button>
          <Button @click="handleReset">重置</Button>
        </div>
        <div class="action-btns">
          <Button type="error" @click="openGlobalSwitch">全局开关</Button>
          <Button type="success" icon="md-add" @click="handleAdd"
            >新增策略</Button
          >
        </div>
      </div>

      <div class="table-container">
        <Table :data="tableData" :columns="columns" :loading="tableLoading">
          <template #action="{ row }">
            <div class="action-buttons">
              <a @click="handleEdit(row)">编辑</a>
              <a class="delete-link" @click="handleDelete(row)">删除</a>
            </div>
          </template>
          <template #footer>
            <Pages :page="page" :func="getData"></Pages>
          </template>
        </Table>
      </div>

      <!-- 全局开关弹窗 -->
      <Modal
        v-model="showGlobalSwitch"
        title="全局开关"
        width="500"
        @on-cancel="cancelGlobalSwitch"
      >
        <Alert type="warning" show-icon style="margin-bottom: 20px">
          只有全局开关设置为开启时，其他国家的配置才会生效
        </Alert>
        <Form :label-width="100">
          <FormItem label="iOS总开关">
            <RadioGroup v-model="globalForm.iosGlobalSwitch" type="button">
              <Radio
                v-for="item in iosGlobalSwitchOptions"
                :label="Number(item.dictValue)"
                :key="item.dictValue"
                >{{ item.dictName }}</Radio
              >
            </RadioGroup>
          </FormItem>
          <FormItem label="安卓总开关">
            <RadioGroup v-model="globalForm.androidGlobalSwitch" type="button">
              <Radio
                v-for="item in androidGlobalSwitchOptions"
                :label="Number(item.dictValue)"
                :key="item.dictValue"
                >{{ item.dictName }}</Radio
              >
            </RadioGroup>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button @click="cancelGlobalSwitch">取消</Button>
          <Button
            type="primary"
            :loading="globalLoading"
            @click="saveGlobalSwitchData"
            >保存修改</Button
          >
        </div>
      </Modal>
    </template>

    <!-- 编辑模式 -->
    <SwitchEdit
      style="height: 100%; overflow: hidden"
      v-else
      :editId="editId"
      @back="handleEditBack"
    />
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import SwitchEdit from './switchEdit.vue'
import MultiCascader from '@/components/MultiCascader'
import {
  getStrategyList,
  delStrategy,
  getGlobalSwitch,
  saveGlobalSwitch
} from '@/api/thirdParty'
import { getDictionaryList } from '@/api/dictionary'

export default {
  name: 'ThirdPartySwitch',
  components: { Pages, SwitchEdit, MultiCascader },
  data() {
    return {
      showEdit: false,
      editId: null,
      tableLoading: false,
      searchForm: {
        countryCodes: [],
        device: '',
        entryPoints: [],
        payMethods: [],
        providers: [],
        name: ''
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      countryLi: [],
      entryOptions: [],
      allMethodOptions: [],
      providerOptions: [],
      iosGlobalSwitchOptions: [],
      androidGlobalSwitchOptions: [],
      columns: [
        {
          title: '策略名称',
          key: 'name',
          minWidth: 150
        },
        {
          title: '国家名称',
          key: 'countryNames',
          minWidth: 150,
          tooltip: true,
          tooltipMaxWidth: 200
        },
        {
          title: '开启设备',
          key: 'enabledDevices',
          width: 140,
          render: (h, params) => {
            return <div>{params.row.enabledDevices || '--'}</div>
          }
        },
        {
          title: 'iOS开放入口',
          key: 'iosEntryPoints',
          minWidth: 180,
          tooltip: true,
          render: (h, params) => {
            return <div>{params.row.iosEntryPoints || '--'}</div>
          }
        },
        {
          title: '安卓开放入口',
          key: 'androidEntryPoints',
          minWidth: 180,
          tooltip: true,
          render: (h, params) => {
            return <div>{params.row.androidEntryPoints || '--'}</div>
          }
        },
        {
          title: '更新日期',
          key: 'updateTime',
          width: 170,
          render: (h, params) => {
            return <div>{params.row.updateTime || '--'}</div>
          }
        },
        { title: '操作', slot: 'action', width: 140, align: 'center' }
      ],
      // 全局开关
      showGlobalSwitch: false,
      globalLoading: false,
      globalForm: {
        iosGlobalSwitch: 0,
        androidGlobalSwitch: 0
      },
      globalFormBackup: null
    }
  },
  computed: {},
  methods: {
    async fetchDictionaries() {
      try {
        const [
          entryRes,
          iosGlobalRes,
          androidGlobalRes,
          countryRes,
          iosMethodRes,
          androidMethodRes,
          providerRes
        ] =
          await Promise.all([
            getDictionaryList({ dictTopic: 'PAY_ENTRY_POINT' }),
            getDictionaryList({ dictTopic: 'PAY_IOS_GLOBAL_SWITCH_OPTIONS' }),
            getDictionaryList({
              dictTopic: 'PAY_ANDROID_GLOBAL_SWITCH_OPTIONS'
            }),
            getDictionaryList({ dictTopic: 'GOODS_COUNTRY_GROUP' }),
            getDictionaryList({ dictTopic: 'PAY_METHOD_TYPE_IOS' }),
            getDictionaryList({ dictTopic: 'PAY_METHOD_TYPE_ANDROID' }),
            getDictionaryList({ dictTopic: 'PAY_PROVIDER_TYPE' })
          ])
        this.entryOptions = entryRes.data.records || entryRes.data || []
        this.iosGlobalSwitchOptions =
          iosGlobalRes.data.records || iosGlobalRes.data || []
        this.androidGlobalSwitchOptions =
          androidGlobalRes.data.records || androidGlobalRes.data || []
        const iosMethods = iosMethodRes.data.records || iosMethodRes.data || []
        const androidMethods =
          androidMethodRes.data.records || androidMethodRes.data || []
        const seen = new Set()
        this.allMethodOptions = [...iosMethods, ...androidMethods].filter(
          (item) => {
            if (seen.has(item.dictValue)) return false
            seen.add(item.dictValue)
            return true
          }
        )
        this.providerOptions = providerRes.data.records || providerRes.data || []

        let countryData = []
        if (countryRes.data && countryRes.data.records) {
          countryData = countryRes.data.records.map((i) => {
            return {
              label: i.dictName,
              value: i.dictName,
              children: i.dictValue.split(',').map((j) => {
                return {
                  value: j.split('|')[0],
                  label: j.split('|')[1]
                }
              })
            }
          })
        }
        this.countryLi = countryData
      } catch (e) {
        console.error('获取字典数据失败', e)
      }
    },
    async getData(current) {
      if (current) this.page.current = current
      this.tableLoading = true
      try {
        const params = {
          current: this.page.current,
          size: this.page.size
        }
        if (
          this.searchForm.countryCodes &&
          this.searchForm.countryCodes.length
        ) {
          params.countryCodes = this.searchForm.countryCodes.join(',')
        }
        if (this.searchForm.device !== '' && this.searchForm.device !== null) {
          params.device = this.searchForm.device
        }
        if (this.searchForm.entryPoints && this.searchForm.entryPoints.length) {
          params.entryPoints = this.searchForm.entryPoints.join(',')
        }
        if (this.searchForm.payMethods && this.searchForm.payMethods.length) {
          params.payMethods = this.searchForm.payMethods.join(',')
        }
        if (this.searchForm.providers && this.searchForm.providers.length) {
          params.providers = this.searchForm.providers.join(',')
        }
        if (this.searchForm.name) {
          params.name = this.searchForm.name
        }
        const { data } = await getStrategyList(params)
        this.tableData = data.records || []
        this.page.total = data.total || 0
      } catch (error) {
        this.$Message.error('获取列表失败')
      } finally {
        this.tableLoading = false
      }
    },
    handleSearch() {
      this.getData(1)
    },
    handleReset() {
      this.searchForm = {
        countryCodes: [],
        device: '',
        entryPoints: [],
        payMethods: [],
        providers: [],
        name: ''
      }
      this.getData(1)
    },
    handleAdd() {
      this.editId = null
      this.showEdit = true
    },
    handleEdit(row) {
      this.editId = row.id
      this.showEdit = true
    },
    handleEditBack() {
      this.showEdit = false
      this.editId = null
      this.getData()
    },
    handleDelete(row) {
      this.$Modal.confirm({
        title: '提示',
        content: `确定要删除该国家策略吗？`,
        onOk: async () => {
          try {
            await delStrategy(row.id)
            this.$Message.success('删除成功')
            this.getData()
          } catch (error) {
            this.$Message.error('删除失败')
          }
        }
      })
    },
    // 全局开关
    async openGlobalSwitch() {
      this.showGlobalSwitch = true
      await this.loadGlobalSwitch()
    },
    async loadGlobalSwitch() {
      try {
        const { data } = await getGlobalSwitch()
        if (data) {
          this.globalForm.iosGlobalSwitch = data.iosGlobalSwitch || 0
          this.globalForm.androidGlobalSwitch = data.androidGlobalSwitch || 0
          this.globalFormBackup = { ...this.globalForm }
        }
      } catch (e) {
        console.error(e)
      }
    },
    cancelGlobalSwitch() {
      this.showGlobalSwitch = false
      if (this.globalFormBackup) {
        this.globalForm = { ...this.globalFormBackup }
      }
    },
    async saveGlobalSwitchData() {
      this.globalLoading = true
      try {
        await saveGlobalSwitch({
          iosGlobalSwitch: this.globalForm.iosGlobalSwitch,
          androidGlobalSwitch: this.globalForm.androidGlobalSwitch
        })
        this.$Message.success('全局开关保存成功')
        this.showGlobalSwitch = false
        this.globalFormBackup = { ...this.globalForm }
      } catch (e) {
        this.$Message.error('保存失败')
      } finally {
        this.globalLoading = false
      }
    }
  },
  mounted() {
    this.fetchDictionaries()
    this.getData()
  }
}
</script>

<style scoped lang="less">
.header-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 10px;
}
.search-form {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.action-btns {
  display: flex;
  gap: 10px;
}
.table-container {
  flex: 1;
  overflow: auto;
}
.action-buttons {
  display: flex;
  justify-content: center;
  gap: 15px;
  a {
    color: #2d8cf0;
    cursor: pointer;
    &:hover {
      color: #57a3f3;
    }
  }
  .delete-link {
    color: #ed4014;
    &:hover {
      color: #f16643;
    }
  }
}
.layout-card {
  display: flex;
  flex-direction: column;
  /deep/ .ivu-card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
  }
}
</style>
